// Keep: useState, useEffect. Remove useRef, FaBell, Spinner, Dropdown, notificationApi, Header.css
import React, { useState, useEffect } from 'react';
// Keep Navbar, Container, Nav, Button, NavLink. Remove Spinner, Dropdown.
import { Navbar, Container, Nav, Button, NavLink } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
// Keep FaHome, FaSignOutAlt, FaList, FaUserTie, FaUserCircle. Remove FaBell.
import { FaHome, FaSignOutAlt, FaList, FaUserTie, FaUserCircle, FaUniversity, FaPercent } from 'react-icons/fa';
import jwt_decode from 'jwt-decode';
// Keep useAuth hook
import { useAuth } from '../hooks/useAuth';
// Remove notification API service import
// import { notificationApi } from '../services/api';
// Keep CSS import for now, but content will be removed
import './Header.css';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [userName, setUserName] = useState('');
  const { getCurrentUser, logout } = useAuth(); // Initialize useAuth and get logout

  // Removed notification state and ref

  const isActive = (path) => {
    return location.pathname === path;
  };

  // Update useEffect for userName to use useAuth primarily
  useEffect(() => {
    const storedUser = getCurrentUser(); // Use useAuth hook
    if (storedUser) {
      setUserName(storedUser.name || storedUser.email || 'User');
    } else {
      // Fallback if needed, though useAuth should handle persistence
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const decoded = jwt_decode(token);
          setUserName(decoded.name || decoded.email || 'User');
        } catch (error) {
          console.error('Error decoding token:', error);
        }
      }
    }
  }, [getCurrentUser]); // Add getCurrentUser dependency

  // Removed useEffect for fetching notifications
  // Removed useEffect for handling clicks outside dropdown

  const handleSignOut = () => {
    logout(); // Use logout from useAuth hook
    navigate('/login');
  };

  // Removed function to toggle notifications

  const handleHomeClick = () => {
    navigate('/admin/dso-list');
  };

  // Log when the component renders
  console.log(`Header rendering`);

  return (
    <Navbar expand="lg" className="mb-4" style={{ 
      background: 'linear-gradient(135deg, #3ca437 0%, #4eb543 40%, #6ed36c 75%, #89e088 100%)',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
    }}>
      <Container fluid>
        <Navbar.Brand className="d-flex align-items-center text-white" onClick={handleHomeClick} style={{ cursor: 'pointer' }}>
          <FaHome className="me-2" /> Home
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link 
              onClick={() => navigate('/admin/dso-list')} 
              className={`text-white ${isActive('/admin/dso-list') ? 'fw-bold' : ''}`}
              style={{ borderBottom: isActive('/admin/dso-list') ? '2px solid white' : 'none' }}
            >
              <FaList className="me-1" /> DSO List
            </Nav.Link>
            <Nav.Link 
              onClick={() => navigate('/admin/rm-list')} 
              className={`text-white ${isActive('/admin/rm-list') ? 'fw-bold' : ''}`}
              style={{ borderBottom: isActive('/admin/rm-list') ? '2px solid white' : 'none' }}
            >
              <FaUserTie className="me-1" /> RM List
            </Nav.Link>
            <Nav.Link 
              onClick={() => navigate('/admin/products')} 
              className={`text-white ${isActive('/admin/products') ? 'fw-bold' : ''}`}
              style={{ borderBottom: isActive('/admin/products') ? '2px solid white' : 'none' }}
            >
              <FaList className="me-1" /> Products
            </Nav.Link>
            <Nav.Link 
              onClick={() => navigate('/admin/banks')} 
              className={`text-white ${isActive('/admin/banks') ? 'fw-bold' : ''}`}
              style={{ borderBottom: isActive('/admin/banks') ? '2px solid white' : 'none' }}
            >
              <FaUniversity className="me-1" /> Banks
            </Nav.Link>
            <Nav.Link 
              onClick={() => navigate('/admin/commissions')} 
              className={`text-white ${isActive('/admin/commissions') ? 'fw-bold' : ''}`}
              style={{ borderBottom: isActive('/admin/commissions') ? '2px solid white' : 'none' }}
            >
              <FaPercent className="me-1" /> Commissions
            </Nav.Link>
          </Nav>
          <Nav>
            {/* Notification Area Removed */}

            {/* Existing Admin/User Info/Sign Out */}
            <Nav.Item className="d-flex align-items-center text-white me-3">
              {/* TODO: Make dynamic based on user role from useAuth */}
              <strong>Admin</strong>
            </Nav.Item>
            <Nav.Item className="d-flex align-items-center text-white me-3">
              <FaUserCircle className="me-2" /> {userName} {/* Use FaUserCircle */}
            </Nav.Item>
            <Button variant="light" size="sm" onClick={handleSignOut}>
              <FaSignOutAlt className="me-2" /> Sign Out
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
